(function ($, window) {
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    var _ = window.mg;

    _.ui.favourites = {
        instances: {},
        set: function (itemHolder, properties) {
            var that = this;
            var inst = (function () {
                var props = $.extend({
                    maxVisibleElements: 10
                }, properties, true);

                props.$itemHolder = $(itemHolder);
                props.$txtFilter = $('.templates .mg-input-search-wrapper .mg-input').clone().addClass('search-favorite hide');
                props.$btnShowMore = $('.templates .btn-show-more').clone().attr('data-item-holder-class', itemHolder).addClass('hide');

                props.$btnShowMore.on('click', function () {
                    mg.ui.showMore.onClick(this, props.maxVisibleElements, null, null, props.$itemHolder);
                });

                props.$itemHolder.prepend(props.$txtFilter); // Insert first
                props.$btnShowMore.insertAfter($('> .favorite:last', props.$itemHolder)); // Insert last

                that.instances[itemHolder] = props;
            })();

            this.update(itemHolder); // Make sure to set the right states
            return inst;
        },
        setFilterListener: function (props) {
            mg.setTxtSearchBehavior(props.$txtFilter, props.filterElements, props.filterProp, props.filterRIDProp);
        },
        getInstance: function (itemHolder) {
            var $itemHolder = $(itemHolder); // This should allow implementations to specify itemHolder as either a selector or a jQuery element
            var id = $itemHolder.attr('id');
            return _.ui.favourites.instances['#' + id];
        },
        update: function (itemHolder) {
            var instance = this.getInstance(itemHolder);

            if (instance) {
                var props = instance;
                var $itemHolder = $(itemHolder);
                var $items = $('> .favorite', instance.$itemHolder);
                var $hiddenItems = $items.filter('.hide');
                var toggled = mg.ui.showMore.getToggled($itemHolder);

                if (!toggled && $items.length > props.maxVisibleElements) {
                    if (props.$btnShowMore.hasClass('hide')) {
                        // Show the Filter and Show More
                        props.$txtFilter.removeClass('hide');
                        props.$btnShowMore.removeClass('hide');
                    }

                    // Update the count
                    mg.ui.showMore.setShowMore({ btnShowMore: props.$btnShowMore }, 'more', $hiddenItems.length);
                }
                else {
                    // Make sure all items are shown
                    $items.removeClass('hide');
                }

                this.setFilterListener(instance); // Make sure this is updated with any changes to the filterElements
            }
        }
    };
})($, window);
